import { render } from "./ModalDelete.vue?vue&type=template&id=2b8ab070&scoped=true"
import script from "./ModalDelete.vue?vue&type=script&lang=js"
export * from "./ModalDelete.vue?vue&type=script&lang=js"

import "./ModalDelete.vue?vue&type=style&index=0&id=2b8ab070&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8ab070"]])

export default __exports__